import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Language } from '../../../tools/language/language';
import { TranslateService } from '@ngx-translate/core';
import { RoutestateService } from 'src/app/tools/routestate/routestate.service';
import { environment } from '../../../../environments/environment';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { GlobalsService } from '../../../services/globals/globals.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() sys: string;
  @Input() lottoId: number;

  langs = environment.multisite.langs;
  lang: any = Language.currentLanguage.lenid;
  setSystem: number = 0;
  showLogin: boolean;
  showRecovery: boolean;
  signInUp: boolean;
  isAuthenticatedByToken: boolean;
  subscription: Subscription;
  profileDetails: any;
  language: Language = new Language();
  passwordResetToken: string;
  logoSpecialDay: string;
  menuActive = '';
  showNavBar = true;

  constructor(
    private _permissionService: StoragePermissionService,
    public dialog: MatDialog,
    private _authService: AuthService,
    private _router: Router,
    private _translate: TranslateService,
    private _stateRoute: RoutestateService,
    private _activatedRoute: ActivatedRoute,
    public globalSrv: GlobalsService,
    private _window: WindorefService
  ) {
    this._router.events.subscribe((val) => {
      const href = window.location.href;
      this.showNavBar = href.includes('/in-maintenance');
    });
  }

  ngOnInit() {
    this.hideNavbar();
    // update active menu
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
      }
      this.menuActive = this._stateRoute.menuActive;
      this._setPromoSticky();
    });

    this.menuActive = this._stateRoute.menuActive;
    this._activatedRoute.queryParams.subscribe((resp) => {
      if (resp.token) {
        this.passwordResetToken = resp.token;
        if (this.passwordResetToken.length > 10) {
          this.showRecovery = true;
        }
      }
    });

    this.subscription = this._authService.isUserLogged.subscribe((isLogged: boolean) => {
      if (isLogged === true) {
        this.profileDetails = this._permissionService.getProfile();
        this.isAuthenticatedByToken = true;
      } else {
        this.isAuthenticatedByToken = false;
      }
    });
    this._setPromoSticky();
  }

  isLogin(e: boolean): void {
    this.showLogin = true;
    e ? (this.signInUp = true) : (this.signInUp = false);
  }

  account() {
    this._router.navigate(['/my-account']);
  }

  changeLanguage(lenid) {
    const found = this.language.dataSourceLenguajeId.find(function (element) {
      return element.lenid === lenid;
    });
    this.language.cambiarLenguaje(found, this._translate, true, this._permissionService);
  }

  hideNavbar(): void {
    const path = this._window.getNativeDocument().location.pathname;
    this.showNavBar = path.includes('/in-maintenance');
  }

  private _setPromoSticky(): void {
    let pathname: string = this._window.getNativeWindow().location.pathname;
    if (pathname.includes('/upsell')) {
      this.lottoId = 0;
    }
  }
}
